import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {Act} from "./story";
import {headers} from "./headers";
import {Tag} from "./fields";
import {host} from "./api";

export interface ActState {
    acts: Array<Act>,
    status: Status,
    act: Act | undefined,
    error: string | null | undefined
}

const initialState: ActState = {
    acts: [],
    status: Status.Idle,
    act: undefined,
    error: null,
}

export const fetchActs = createAsyncThunk('fetchActs', async (params: { projectId: number, storyId: number }) => {
    const response = await axios.get(`${host}/stories/${params.storyId}/acts`, {
        headers: headers(params.projectId?.toString())
    })
    return response.data
})

export const fetchAct = createAsyncThunk('fetchAct', async (params: { projectId: number, actId: number }) => {
    const response = await axios.get(`${host}/acts/${params.actId}`, {
        headers: headers(params.projectId?.toString())
    })
    return response.data
})

export const saveAct = createAsyncThunk('saveAct', async (params: { projectId: number, act: Act }) => {
    const response = await axios.post(`${host}/acts`,
        params.act,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const deleteAct = createAsyncThunk('deleteAct', async (params: { projectId: number, actId: number }) => {
    const response = await axios.delete(`${host}/acts/${params.actId}`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const removeActTag = createAsyncThunk('removeActTag', async (params: {
    projectId: number,
    actId: number,
    tagId: number
}) => {
    const response = await axios.delete(`${host}/acts/${params.actId}/tags/${params.tagId}`,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const addActTag = createAsyncThunk('addActTag', async (params: {
    projectId: number,
    actId: number,
    tag: Tag
}) => {
    const response = await axios.post(`${host}/acts/${params.actId}/tags`,
        params.tag,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const actsSlice = createSlice({
    name: 'acts',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchActs.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchActs.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.acts = action.payload
            })
            .addCase(fetchActs.rejected, (state, action) => {
                state.status = Status.Failed
                state.error = action.error.message
            })
            .addCase(removeActTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(removeActTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addActTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addActTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(saveAct.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveAct.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(fetchAct.pending, (state, action) => {
                state.status = Status.Loading
                state.act = undefined
            })
            .addCase(fetchAct.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.act = action.payload
            })
            .addCase(deleteAct.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteAct.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
    }
})

export default actsSlice.reducer;